var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,22.2l0.1-0.1L30.5,22.2c1.5,1.3,2.3,3.2,2.3,5.2v2.2c0,1.9-1.5,3.4-3.4,3.4h-23c-1.9,0-3.4-1.5-3.4-3.4v-2.2 c0-2,0.8-3.9,2.3-5.2h0c1.2-1.1,3.5-2.6,7.3-3.5l0.3-0.1l-0.3-0.2c-2-1.6-3.3-4-3.3-6.8c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5 c0,4.7-3.8,8.5-8.5,8.5c-6.5,0-10,2.4-11.2,3.5c-1,0.9-1.6,2.2-1.6,3.6v2.2c0,0.7,0.6,1.3,1.3,1.3h23c0.7,0,1.3-0.6,1.3-1.3v-2.2 c0-1.4-0.6-2.7-1.6-3.6c-0.8-0.7-1.8-1.4-3-1.9c-0.5-0.2-0.7-0.8-0.5-1.3c0.2-0.5,0.8-0.7,1.3-0.5C28.3,20.5,29.5,21.3,30.5,22.2z  M18,5.2c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5C24.5,8.1,21.6,5.2,18,5.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoUser);
export default __webpack_public_path__ + "static/media/picto-user.301ab048.svg";
export { ForwardRef as ReactComponent };